import type {
  GatorProtectGlobalsDependencies,
} from '../GatorProtectGlobals.types';
import type { GPModalsVariants } from '../gatorProtectModalsVisibilityReducer';
import type { GatorProtectModalHookReturn } from '../gatorProtectModalHooks.types';
import type { HideGatorProtectModalSlot } from '../useGatorProtectModalsVisibility';

export const GP_MODAL_VARIANT_AUTOMATED_SECURITY_VIDEO = 'automatedSecurityVideo' as const;

export type GatorProtectAutomatedSecurityVideoProps = {
  onClose: () => void;
  onPrimary: () => void;
  onSecondary: () => void;
};

export type GatorProtectAutomatedSecurityVideoLocale = {
  gatorProtect?: {
    automatedSecurityVideo: {
      title: string,
      primaryCta: string,
      secondaryCta: string,
    },
  };
};

export type UseGatorProtectAutomatedSecurityVideoParams = {
  summary: GatorProtectGlobalsDependencies['summary'];
  isHome: boolean;
  hideModalSlot: HideGatorProtectModalSlot;
};

export type UseGatorProtectAutomatedSecurityVideoData = Record<string, never>;

export type UseGatorProtectAutomatedSecurityVideoUtils = {
  hideAutomatedSecurityVideo: (_topStackModalVariant: GPModalsVariants | null) => void;
  redirectAutomatedSecurityVideo: () => void;
};

export type UseGatorProtectAutomatedSecurityVideoReturn = GatorProtectModalHookReturn<
  UseGatorProtectAutomatedSecurityVideoData,
  UseGatorProtectAutomatedSecurityVideoUtils
>;
